import { css, type Theme } from "@emotion/react";

import { slideContentInset } from "../../SideCarouselPanel.styles";

import qualityProgramSlideBg from "./assets/qualityProgramSlideBg.webp";

export const slide = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${slideContentInset(theme)};
  background-image:
    linear-gradient(rgba(30, 30, 30, 0.4), rgba(30, 30, 30, 0.4)), url(${qualityProgramSlideBg});
  background-size: cover;
  background-position: center;
`;

export const content = css`
  display: flex;
  flex-direction: column;
  max-width: 360px;
`;

export const heading = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.spacing.gap.medium};
`;

export const titleEmphasis = css`
  display: block;
  font-style: italic;
`;

export const features = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.spacing.gap.large};
  margin-top: ${theme.ds5.spacing.gap.large};
`;
